import Graphics from './graphics';

export default Graphics;
